import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSortAsc = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 9,
	height: 13,
	viewBox: "0 0 9 13",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M0.634125 5.00093L4.19395 5.00596L7.39952 5.01048C7.94806 5.01126 8.22341 4.25273 7.83548 3.8073L4.8804 0.414183C4.4069 -0.129501 3.63551 -0.13059 3.16048 0.411755L2.03301 1.69901L0.195846 3.79651C-0.18762 4.24086 0.0855808 5.00016 0.634125 5.00093Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		opacity: .5,
		d: "M7.39491 7.00961L3.8351 7.00027L0.629532 6.99185C0.0809888 6.99041 -0.195275 7.7486 0.192108 8.19451L3.14307 11.5912C3.61591 12.1355 4.3873 12.1375 4.86298 11.5957L5.99202 10.3098L7.83173 8.21457C8.21573 7.77069 7.94345 7.01106 7.39491 7.00961Z",
		fill: "currentColor"
	})]
});
export default SvgSortAsc;
